import { css } from 'styled-components';

import { AnchorProps } from './Anchor';

export default css<AnchorProps>`
  line-height: inherit;
  text-decoration: underline;
  text-underline-offset: 0.25em;
  cursor: pointer;
  ${({
    theme: {
      color: { link },
    },
  }) =>
    css`
      color: ${link.base.value};

      &:hover {
        color: ${link.hover.value};
      }

      &:focus {
        color: ${link.focus.value};
      }

      &:active {
        color: ${link.active.value};
      }
    `}

  ${({ underline = true }) =>
    underline === false &&
    css`
      text-decoration: none;
    `}

  ${({ underlineOnHover = true }) =>
    underlineOnHover === false &&
    css`
      &:hover,
      &:focus,
      &:active {
        text-decoration: none;
      }
    `}

  ${(props) =>
    !!props.icon &&
    css`
      text-decoration: none;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none;
      }
    `}


  ${({
    secondary,
    theme: {
      color: { base },
    },
  }) =>
    secondary &&
    css`
      color: ${base.brand.white.value};

      &:hover,
      &:focus,
      &:active {
        color: ${base.brand.white.value};
      }
    `}

  .fil-icon-wrapper {
    ${({ iconPosition = 'right' }) =>
      iconPosition === 'left' &&
      css`
        margin-right: 0.5rem;
      `}
    ${({ iconPosition = 'right' }) =>
      iconPosition === 'right' &&
      css`
        margin-left: 0.5rem;
      `}
  }
`;
